<template>

  <div>
    <el-form style="margin-right: 30px;" :rules="rules" ref="pwdForm" :model="pwdForm">

      <el-form-item label="项目编号" :label-width="formLabelWidth" prop="Mobile">
        <el-input v-model="pwdForm.Mobile" autocomplete="off"></el-input>
      </el-form-item>

      

      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px;">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="confirmAction('pwdForm')" :disabled="disableSubmit">确 定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'ResetPwdForm',

    props: {
      editPwd: {
        type: Object,
        default: ()=>{
		return {};
	}
      }
    },
    watch: {
      pwdForm (newValue, oldValue){
		this.pwdForm = newValue;
	
      }
    },
    mounted () {
      
    },
    methods: {
      closeDialog () {
        this.$emit('clickCancel')
      },
      confirmAction (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.closeDialog()
            // this.clearData()
            this.$emit('clickConfirm', this.pwdForm)
          } else {
            return false
          }
        })
      },
      clearData () {
        this.pwdForm.number = ''
        
      }
    },


    data () {

      return {
        disableSubmit:false,
        rules: {
          Mobile: [
            {
              required: true,
              message: '请输入项目编号',
              trigger: 'blur'
            }
          ]
        },
        formLabelWidth: '100px',
        pwdForm: this.editPwd
      }
    }
  }
</script>

<style scoped>

</style>
